import Price from "components/Price/Price"
import { Col, Row } from "elemental-react16"
import { Button, Card, Icon, Modal, Segment, Image, Message,Table, Progress, Loader } from "semantic-ui-react"
import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import React, { Component, Fragment, useState } from "react"
import shop from "shop/shop"
import ProductImageDownloader from "util/ProductImageDownloader"
import OneClickReorderModal from "components/OneClickReorder/OneClickReorderModal"
import _ from "lodash"
import moment from "moment"
import "moment/locale/de"
import CostCentres  from "components/CostCentres/CostCentres";
import AccountReset from "components/Account/AccountReset"
import swal from "sweetalert"
import OrderModel from "../../../shop/OrderModel";
import { Redirect } from "react-router"
import NewCustomerContactPage from "./NewCustomerContactPage"
import MediaQuery from "react-responsive"
import languageStore               from "stores/languageStore"
import AccountOrderDetailPage from "./AccountOrderDetailPage"


const setPasswordAsAdmin = ( account ) => {

  swal( {
      text            : "Passwort setzen",
      type            : "prompt",
      title           : "Neues Passwort",
      showCancelButton: true,
      closeOnConfirm  : false,
      closeOnCancel   : true,
    },
    newPassword => {
      if ( !newPassword ) return
      shop.fetch( `/shop/rest/security/user/${account.userid}/logins?passupdate=1`, {
        method: "POST",
        body  : JSON.stringify( {
          ...account,
          "password": newPassword,
          "newpass" : newPassword,
          "repeat"  : newPassword
        } )
      } )
        .then( res => {
          console.log( "PW CHANGE", res )
          swal( translate( "reset.success" ),
            translate( "Passwort erfolgreich gesetzt." ),
            "success" )
        } )
        .catch( err => {
          console.error( err )
          swal( "Fehler", "Leider konnte IhrPasswort nicht geändert werden", "error" )
        } )

    }
  )
}

export function fetchExtraOrderRessources( order ) {
  return shop.fetch( `/shop/rest/data/customer/current/extrainfo?start=0&count=50&subref=${order.map_id}` )
    .then( res => {
      order.extrainfo = res.map( data => new OrderPDF( data ) )
      return new OrderModel(order)
    } )
}


class Accounts extends React.Component {

  state = {
    loading : false,
    accounts: [],
    user: false,
  }

  async componentDidMount() {
    this.setState( { loading: true } )

    const users    = await shop.fetch( `/shop/rest/users/data?start=0&count=100&filter=%7B%22customer_id%22%3A%22${shop.session.value.map_id}%22%7D`)

    var temp;
    if (users.length > 0) {
      this.user = users[0];
      temp = await shop.fetch( `/shop/rest/security/user/${users[0].id}/logins` )
    } else {
      temp = [];
    }

    const accounts = temp;
    console.log( { accounts } )
    this.setState( { accounts, loading: false } )
  }

  render() {
    const { accounts } = this.state
    return <div>
      <Segment.Group>
        {accounts.map( account => {
          return <Segment clearing key={account.login}>
            <Button floated={"right"}  onClick={() => setPasswordAsAdmin( account )}>{translate( "change Password" )}</Button>
            <div className="pa2 b">{account.login} {account.contact}</div>
          </Segment>
        } )}
      </Segment.Group>
    </div>
  }
}

export const orderTypes = {
  0: "Order",
  1: "Delivery",
  2: "Invoice",
}

class OrderPDF {
  constructor( order ) {
    Object.assign( this, order )
    this.typeName = orderTypes[ order.type ] || "Unknown"
    this.url = `${shop.config.BASE}/shop/rest/data/customer/current/extraresources/` + encodeURIComponent(order.map_id)
  }
}

@observer
export default class AccountPage extends Component {

  state = {
    session        : shop.session || {}, locations: [],
    orders         : [],
    current        : 0,
    showAddressBook: false,
    noMoreOrders   : false,
    frachtkosten: true,
    openTab: "dashboard",
    loadFullHistory: false,
    mobileMenuOpen: false,
    mobileNavVisible: true,
    selectedOrderId: null,
    orderDetailSlideOut: false,
    loadingOrders: false,
  }

  openOrderDetail = (orderId) => {
    this.setState({ selectedOrderId: orderId, orderDetailSlideOut: false })
  }

  closeOrderDetail = () => {
    this.setState({ orderDetailSlideOut: true })
    setTimeout(() => this.setState({ selectedOrderId: null, orderDetailSlideOut: false }), 350)
  }

  loadMore = () => {
    let { orders, current } = this.state
    let pageSize = 250
    let start = current
    current = current + pageSize
    this.setState( { loadingOrders: true } )
    shop.fetch( `/shop/rest/data/orders?start=${start}&count=${pageSize}&open=0&filter=[{"field":"customerId","op":"equals","value":"${shop.session.value.map_id}"}]` )
      .then( async res => {
        let extras = res.values.map( order => fetchExtraOrderRessources( order ) )
        await Promise.all( extras )
        console.log( "FROM API", { res } )
        orders = orders.concat( res.values )
        this.setState( { loadingOrders: false, current, orders } )
        if ( res.values.length === 0 ) {
          this.setState( { noMoreOrders: true, current, orders } )
        }
      } )
  }

  loadSession = ( session ) => {
    this.loadMore()
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        this.setState( { locations } )
      } )
  }

  componentDidMount() {
    shop.events.authentified.add( this.loadSession )
    console.log("this.props", this.props, this.props.location.search)
    if(this.props.location.search.includes("_order")){
      this.setState({ openTab: "order", mobileNavVisible: false });
    }
    if(this.props.location.search.includes("_address")){
      this.setState({ openTab: "address", mobileNavVisible: false });
    }
    if(this.props.location.search.includes("_contact")){
      this.setState({ openTab: "contact", mobileNavVisible: false });
    }
    if(this.props.location.search.includes("_frameworkAgreement")){
      this.setState({ openTab: "frameworkAgreement", mobileNavVisible: false });
    }
    if(this.props.location.search.includes("_newsletter") && shop.config.plugin.newsletterContact ){
      this.setState({ openTab: "newsletter", mobileNavVisible: false });
    }
  }

  componentWillUnmount() {
    shop.events.authentified.remove( this.loadSession )
  }

  handleTabButtons = (name) => {
    this.setState({ openTab: name, mobileMenuOpen: false, mobileNavVisible: false, selectedOrderId: null, orderDetailSlideOut: false });
  }

  handleMobileBack = () => {
    this.setState({ mobileNavVisible: true });
  }

  toggleMobileMenu = () => {
    this.setState(prev => ({ mobileMenuOpen: !prev.mobileMenuOpen }));
  }

  // ─── NEW SIDEBAR LAYOUT ────────────────────────────────────────────────────
  renderNewLayout({ locations, orders, noMoreOrders, frachtkosten, openTab, loadFullHistory, mobileNavVisible, billingAddress, shortlist, locationsOnDisplay, note, loadingOrders }) {

    const isQuickOrderPlus = shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme === "QuickOrderPlus"

    const navItems = [
      { key: "dashboard",          label: translate("Dashboard") },
      { key: "address",            label: translate("Adressen") },
      { key: "order",              label: translate("Bestellungen") },
      ...(!isQuickOrderPlus && shop.config.plugin.frameworkAgreement
        ? [{ key: "frameworkAgreement", label: translate("Rahmenaufträge") }]
        : []),
      ...(!isQuickOrderPlus
        ? [{ key: "contact", label: translate("Ansprechpartner") }]
        : []),
      ...(!isQuickOrderPlus && shop.config.plugin.newsletterContact
        ? [{ key: "newsletter", label: translate("Newsletter") }]
        : []),
    ]

    return (
      <div className={`raeder-account-page `}>
        <div className="container">
          <h1 className="raeder-account-title">Dein Konto</h1>

          <div className={`raeder-account-layout${!mobileNavVisible ? " raeder-mobile-content-active" : ""}`}>
          <div className="raeder-mobile-slider">

            {/* ── Sidebar ── */}
            <aside className="raeder-account-sidebar">
              {/* Navigation */}
              <nav className="raeder-account-nav">
                {navItems.map(item => (
                  <button
                    key={item.key}
                    className={`raeder-account-nav-item${openTab === item.key ? " active" : ""}`}
                    onClick={() => this.handleTabButtons(item.key)}
                  >
                    <span>{item.label}</span>
                    <span className="raeder-nav-chevron">›</span>
                  </button>
                ))}
                <div className="raeder-account-nav-divider" />
                <div className="raeder-account-logout-wrap">
                  <a
                    href="#"
                    className="raeder-account-logout-link"
                    onClick={e => {
                      window.location.href = "/logout"
                    }}
                  >
                    <Icon name="sign out alternate" />
                    {translate("Abmelden")}
                  </a>
                </div>
              </nav>
            </aside>

            {/* ── Content ── */}
            <main className="raeder-account-content raeder-account-content-wrapper">
              {/* Mobile back button */}
              <button className="raeder-mobile-nav-back-btn" onClick={this.handleMobileBack}>
                <Icon name="chevron left" />
              </button>

              {/* BESTELLUNGS-DETAILANSICHT (inline, mit Slide-Animation) */}
              {this.state.selectedOrderId && (
                <div className={`raeder-order-detail-panel${this.state.orderDetailSlideOut ? " raeder-order-slide-out" : ""}`}>
                  <AccountOrderDetailPage
                    embedded={true}
                    orderId={this.state.selectedOrderId}
                    onBack={this.closeOrderDetail}
                  />
                </div>
              )}

              {/* NORMALE TAB-INHALTE — ausgeblendet wenn Detail offen */}
              {!this.state.selectedOrderId && <Fragment>

              {/* DASHBOARD */}
              {openTab === "dashboard" && (
                <Fragment>
                  <div className="raeder-section-header">
                    <span>{translate("Deine Daten auf einen Blick")}</span>
                  </div>

                  <div className="raeder-account-data-grid">
                    <div>
                      <div className="raeder-data-block-title">{translate("Deine Persönliche Daten")}</div>
                      <div className="raeder-data-block-divider" />
                      <div className="raeder-data-block-body">
                        <div>{billingAddress.title}</div>
                        {billingAddress.email && <div>{billingAddress.email}</div>}
                        {billingAddress.phone && <div>{billingAddress.phone}</div>}
                      </div>
                    </div>
                    <div>
                      <div className="raeder-data-block-title">{translate("Kundennummer")}</div>
                      <div className="raeder-data-block-divider" />
                      <div className="raeder-data-block-body">
                        {billingAddress.map_id}
                      </div>
                    </div>
                  </div>
                  {/*<div className="raeder-section-header" style={{ marginTop: "32px" }}>
                    <span>{translate("Adressen")}</span> 
                  </div>*/}
                  <section className="pt3">
                    <Adresses billingAddress={billingAddress} openTab={openTab} />
                  </section>
                  
                  <section>
                    <div className="raeder-section-header">
                      <span>{translate("Passwort ändern")}</span>
                      </div>
                      <AccountReset email={shop.session.value.email}/>
                  </section>
                  {/*<div className="raeder-section-header" style={{ marginTop: "32px" }}>
                    <span>{translate("Order History")}</span>
                  </div>
                  <section className="pb5">
                    <div className="flex flex-row justify-end pb3">
                      <Button
                        className="tc"
                        primary
                        style={{ width: "260px", borderRadius: "35px", height: "44px" }}
                        onClick={() => this.handleTabButtons("order")}
                      >
                        <p className="fw7">{translate("Alle Bestellungen anzeigen")}</p>
                      </Button>
                    </div>
                    {orders.length >= 0 && <OrderTable rahmenauftrag={false} orders={orders.slice(0, 3)} />}
                    {!orders.length && <p className="black-60">{translate("No Orders")}</p>}
                  </section> */}
                </Fragment>
              )}

              {/* ADRESSEN */}
              {openTab === "address" && (
                <Fragment>
                  <div className="raeder-section-header">
                    <span>{translate("Adressen")}</span>
                  </div>
                  <p className="fw5 f5 pb3">{translate("OrderAddressHint")}</p>
                  <Adresses billingAddress={billingAddress} openTab={openTab} />
                  {shortlist.length > 0 && (
                    <div className="raeder-section-header" style={{ marginTop: "32px" }}>
                      <span>{translate("Adressbuch")}</span>
                    </div>
                  )}
                  {locationsOnDisplay}
                </Fragment>
              )}

              {/* BESTELLUNGEN */}
              {openTab === "order" && (
                <Fragment>
                  <div className="raeder-section-header">
                    <span>{translate("Bestellungen")}</span>
                  </div>
                  {orders.length >= 0 && (
                    <OrderTable rahmenauftrag={false} orders={!loadFullHistory ? orders.slice(0, 6) : orders} onOrderClick={this.openOrderDetail} />
                  )}
                  {loadingOrders && (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                      <Loader active/>
                    </div>
                  )}
                  {!orders.length && !loadingOrders && <p className="black-60">{translate("No Orders")}</p>}
                  {noMoreOrders && <div className="pb3">{translate("Gesamter Bestellverlauf wird angezeigt")}</div>}
                  {!loadFullHistory && (
                    <div className="pt3 pb3 flex flex-row justify-center">
                      <Button
                        className="tc"
                        primary
                        style={{ width: "300px", borderRadius: "35px", height: "50px", backgroundColor: "#e15635", color: "black" }}
                        onClick={() => this.setState({ loadFullHistory: true })}
                      >
                        <p className="fw7">{translate("Alle Bestellungen anzeigen")}</p>
                      </Button>
                    </div>
                  )}
                </Fragment>
              )}

              {/* RAHMENAUFTRÄGE */}
              {openTab === "frameworkAgreement" && (
                <Fragment>
                  <div className="raeder-section-header">
                    <span>{translate("Rahmenaufträge")}</span>
                  </div>
                  {orders.length >= 0 && <OrderTable rahmenauftrag={true} orders={orders} onOrderClick={this.openOrderDetail} />}
                  {!orders.length && <p className="black-60">{translate("No Orders")}</p>}
                  {noMoreOrders && <div>{translate("Gesamter Bestellverlauf wird angezeigt")}</div>}
                </Fragment>
              )}

              {/* ANSPRECHPARTNER */}
              {openTab === "contact" && (
                <section>
                  <div className="raeder-section-header">
                    <span>{translate("Ihr persönlicher Ansprechpartner")}</span>
                  </div>
                  <div className="pb4">
                    <div className="pb3">
                      <Link className="logo" to="/home/">
                        <img
                          style={{ width: "280px" }}
                          src={"/image/03_Wortmarke/Wortmarke_raeder_schwarz.png"}
                          alt=""
                        />
                      </Link>
                    </div>
                    <p className="f5 fw7 pb3">{translate("Vertriebsinnendienst")}</p>
                    <div className="flex flex-wrap" style={{ gap: "16px" }}>
                      <a href="tel:+495916101720">
                        <span className="f6 fw5" style={{ color: "#e15635" }}>
                          <Icon name="phone" />+49 (0) 591 / 6 10 17 20
                        </span>
                      </a>
                      <a href={`mailto:vertrieb@trendimport.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${billingAddress.map_id}`}>
                        <span className="f6 fw5" style={{ color: "#e15635" }}>
                          <Icon name="mail" />vertrieb@trendimport.de
                        </span>
                      </a>
                    </div>
                  </div>
                  <NewCustomerContactPage />
                </section>
              )}

              {/* NEWSLETTER */}
              {openTab === "newsletter" && (
                <Fragment>
                  <div className="raeder-section-header">
                    <span>{translate("Newsletter")}</span>
                  </div>
                  <div className="raeder-newsletter-intro">
                    <div className="f2 fw6 pb4">{translate("Neues entdecken.")}</div>
                    <div className="f2 fw6 pb4">{translate("Informiert bleiben.")}</div>
                    <div className="fw5 f5 pb2">
                      {translate("Bleiben Sie immer auf dem Laufenden – mit unseren Produkt-Highlights, exklusiven Aktionen und den neuesten Unternehmens-News.")}
                    </div>
                    <div className="fw5 f5">
                      {translate("Melden Sie sich jetzt an und verpassen Sie keine Vorteile mehr!")}
                    </div>
                  </div>
                  <NewCustomerContactPage newsletter={true} />
                </Fragment>
              )}

              {note && (
                <React.Fragment>
                  <div className="row-title tl">
                    <h2>{translate("Kundendaten")}</h2>
                  </div>
                  <div className="pre-line pb4">{note}</div>
                </React.Fragment>
              )}

              </Fragment>}
              {/* Ende normale Tab-Inhalte */}

            </main>
          </div>{/* end raeder-mobile-slider */}
          </div>
        </div>
      </div>
    )
  }
  // ──────────────────────────────────────────────────────────────────────────

  render() {
    let { locations, loading, noMoreOrders, orders, frachtkosten, openTab, loadFullHistory, mobileMenuOpen, mobileNavVisible, loadingOrders } = this.state
    let billingAddress = shop.session.value
    let shortlist = locations.slice( 0, 100 )
    console.log("this.props", this.props, this.props.location.search)

    if ( !shop.session ) return <Redirect to={"/"}/>
    if ( !shop.session.value ) return <Redirect to={"/"}/>
    if ( !shop.session.value.extras ) return <Redirect to={"/"}/>
    console.log("location0",locations[0])
    const note = shop.config.showNote && shop.session.value.extras[ "ts-note" ]
    if(shop.session.value.extras){
      if(shop.session.value.extras.mainlink){
        if(!locations){
          locations = [];
        }
        if(locations.length == 0 && shop.session.value.extras.mainlink != 'yes'){
          locations[0] = [];
          locations[0].mapid = shop.session.value.extras.mainlink;
          if(shop.session.value.extras.linkcountry){ locations[0].country = shop.session.value.country; }
          if(shop.session.value.extras.linkstreet){ locations[0].street = shop.session.value.street; }
          if(shop.session.value.extras.linktitle){ locations[0].name1 = shop.session.value.title; }
          if(shop.session.value.extras.linkpcode){ locations[0].pcode = shop.session.value.pcode; }
          if(shop.session.value.extras.linkcity){ locations[0].city = shop.session.value.city; }
        }
      }
    }
    console.log("location0POST",frachtkosten)

    let locationsOnDisplay = _.map( shortlist, ( location, key ) => {
      const isMobile = window.innerWidth <= 767;
      const groupSize = isMobile ? 1 : 3;
      if (key % groupSize === 0) {
        const rowLocations = shortlist.slice(key, key + groupSize);
        return (<Fragment key={key}>
          <MediaQuery minWidth={768}>
                                <Table key={key} className="accountTableHistory mb3">
        <colgroup>
          <col width="33%" />
          <col width="33%" />
          <col width="34%" />
        </colgroup>
        <tbody>
          <tr>
            {rowLocations.map((loc, idx) => (
          <td className="tl" key={idx}>
            <div className="AccountPageAddress" sm="1" style={{ minHeight: "200px" }}>

            <Address location={loc} address={true}/>
            </div>
          </td>
            ))}
            {rowLocations.length < 3 &&
          Array.from({ length: 3 - rowLocations.length }).map((_, i) => (
            <td key={`empty-${i}`}>

            </td>
          ))}
          </tr>
        </tbody>
          </Table>
            </MediaQuery>
          <MediaQuery maxWidth={767}>
            <Fragment className="tc" key={key}>
            {rowLocations.map((loc, idx) => (
          <Fragment className="tc" key={idx}>
            <div className="pt3 b black-60">{translate("Lieferadresse")}</div>
            <Address location={loc} />
          </Fragment>
            ))}
            </Fragment>
            </MediaQuery>

        </Fragment>

        );
      }
      return null;
    } )

    // ── New sidebar layout ─────────────────────────────────────────────────
    if (shop.config.plugin && shop.config.plugin.accountPageReDesign) {
      return this.renderNewLayout({
        locations, orders, noMoreOrders, frachtkosten, openTab, loadFullHistory,
        mobileMenuOpen, mobileNavVisible, billingAddress, shortlist, locationsOnDisplay, note, loadingOrders
      })
    }
    // ──────────────────────────────────────────────────────────────────────

    return (<Fragment>
        <div className="accountPageHeader raederTopper">
          <div  className="container pt4 ">
            <MediaQuery minWidth={768}>
                          <Table className="accountTablePW" >
              <tbody>
              <tr>
                <td className="tl">
                  <p className="fw7 f2">{shop.session.value.title}</p>
                </td>
                <td className="tr">
                </td>
              </tr>
              <tr>
                <td className="tl">
                  <p className="fw7 f3">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                </td>
                <td className="fr">
                  <div className="tr"><AccountReset email={shop.session.value.email}/></div>
                </td>
              </tr>
              </tbody>
            </Table>
              </MediaQuery>
              <MediaQuery maxWidth={767}>
                <div className="flex flex-column items-start">
                  <div className="pb2"><p className="fw7 f3">{shop.session.value.title}</p></div>
                  <div className="pb3 pt2">
                    <p className="fw7 f4">{translate( "Kundennummer" )}: {shop.session.value.map_id}</p>
                  </div>
                  <div className="pb4 pt2"><AccountReset email={shop.session.value.email}/> </div>
                </div>
                </MediaQuery>
            <div className="flex flex-row justify-start w-100"
                                      style={{
                          overflowX: "auto",
                          WebkitOverflowScrolling: "touch",
                          whiteSpace: "nowrap",
                          msOverflowStyle: "none",
                          scrollbarWidth: "none",
                          }} >
								<div className="pl2 pb2" style={{borderBottom: `${openTab == "dashboard" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
								<button  className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "dashboard" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("dashboard")}><span className="pa2 fw7 f4">{translate("Dashboard")}</span></button></div>
									<div className=" pb2" style={{borderBottom: `${openTab == "address" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
								<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "address" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("address")}><span className="pa2 fw7 f4">{translate("Adressen")}</span></button></div>
                <div className=" pb2" style={{borderBottom: `${openTab == "order" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
								<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "order" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("order")}><span className="pa2 fw7 f4">{translate("Bestellungen")}</span></button></div>

              {shop.config.bShop_Theme && shop.config.bShop_Theme.bshop_frontend_theme !== "QuickOrderPlus" && <Fragment>{shop.config.plugin.frameworkAgreement && <div className=" pb2" style={{borderBottom: `${openTab == "frameworkAgreement" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
              						<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "frameworkAgreement" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("frameworkAgreement")}><span className="pa2 fw7 f4">{translate("Rahmenaufträge")}</span></button></div>
               }
               <div className=" pb2" style={{borderBottom: `${openTab == "contact" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
								<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "contact" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("contact")}><span className="pa2 fw7 f4">{translate("Ansprechpartner")}</span></button></div>
              {shop.config.plugin.newsletterContact && <div className=" pb2" style={{borderBottom: `${openTab == "newsletter" ? "2px solid #e15635" : "2px solid rgb(201, 201, 201)"}`}}>
								<button className="buttonAccountPage" style={{ borderTop: "none", borderLeft: "none", borderRight: "none", borderBottom: `${openTab == "newsletter" ? "none" : "none"}`,
									backgroundColor: `#F8F7EC`, }} onClick={() => this.handleTabButtons("newsletter")}><span className="pa2 fw7 f4">{translate("Newsletter")}</span></button></div>}
									<div className="w-100" style={{borderBottom: "2px solid rgb(201, 201, 201)"}}></div></Fragment>}
							</div>

          </div>
        </div>
        <div className={openTab == "newsletter" ? "accountPageBodyNewsletter" : "accountPageBody"}>
          <div className="container pt4">
            {openTab == "dashboard" && <Fragment>
               <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "My Account" )}</p>
              </div>
              <p className="fw5 f4">{translate( "View your customer data and recent orders" )}</p>

              <div className="pb3 pt3">
                <p className="f3 fw7"> {translate( "Adressen" )}</p>
              </div>

              <section>
                <Adresses billingAddress={billingAddress} openTab={openTab}/>
              </section>

                <section className="mt4 pb5">
                <Row>
                  <Col sm="1">
                    <Table className="accountTableHistory" >
                    <tbody>
                    <tr>
                      <td className="tl">
                        <p className="fw7 f3 pb3 ">{translate( "Order History" )}</p>
                      </td>
                      <td className="fr">
                        <div className="tr">
                          <Button className="tc mb3" primary style={{width: "300px", borderRadius: "35px", height: "50px"}} onClick={() => this.handleTabButtons("order")}>
                            <p className="fw7">{translate( "Alle Bestellungen anzeigen" )}</p>
                          </Button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </Table>
                    {orders.length >= 0 && <OrderTable rahmenauftrag={false} orders={orders.slice(0, 3)}/>}
                    {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
                    {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}

                  </Col>
                </Row>
              </section>
            </Fragment>}
            {openTab == "address" && <Fragment>
              <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Adressen" )}</p>
              </div>
              <p className="fw5 f4">{translate( "OrderAddressHint" )}</p>

              <Adresses billingAddress={billingAddress} openTab={openTab}/>
              {shortlist.length > 0 &&  <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Adressbuch" )}</p>
              </div>}
              {locationsOnDisplay}
              </Fragment>}

            {openTab == "order" && <Fragment>
                            <div className="pb3 pt3">
                <p className="f2 fw7"> {translate( "Bestellungen" )}</p>
              </div>
                    {orders.length >= 0 && <OrderTable rahmenauftrag={false} orders={!loadFullHistory ? orders.slice(0, 6) : orders}/>}
                    {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
                    {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}
                    {!loadFullHistory && <div className="pt3 pb3 flex flex-row justify-center">
                      <Button className="tc mb3" primary style={{width: "300px", borderRadius: "35px", height: "50px", backgroundColor: "#E3E0CA", color: "black"}} onClick={() => {
                      this.setState({ loadFullHistory: true });
                    }}>
                      <p className="fw7">{translate( "Alle Bestellungen anzeigen" )}</p>
                    </Button></div>}
              </Fragment>}
        {note && <React.Fragment>
          <div className="row-title tl">
            <h2>{translate( "Kundendaten" )}</h2>
          </div>
          <div className={"pre-line pb4"}>{note}</div>
        </React.Fragment>}


      { openTab == "contact" && <section className="pt4">
            <div className="pb3 pt3">
              <p className="f2 fw7"> {translate( "Ihr persönlicher Ansprechpartner" )}</p>
            </div>
            <div className="flex flex-row justify-start pt3 pb3" >

            <div className="pb3 ">
               <table>
                <colgroup>
                  <col width="50%"/>
                  <col width="50%"/>
                </colgroup>
                <tbody>
                  <tr>
                    <td colSpan="2" className="pt4">
               <div className="pb3" >
                <Link className={"logo"} to="/home/">
                  <img style={{width: "450px"}}
                    src={"/image/03_Wortmarke/Wortmarke_raeder_schwarz.png"}
                    alt="" />
                </Link>
                </div>
                    <p className="f4 fw7 pl2">{translate("Vertriebsinnendienst")}</p>
                    </td>
                    </tr>
                  <tr>
                    <td className="pt3 pa2" style={{ minWidth: "170px" }}>
                      <a href={`tel:+495916101720`}><span className="f6 fw5" style={{ color: "#e15635", backgroundColor: "transparent" }}><Icon
                                name={"phone"} />+49 (0) 591 / 6 10 17 20</span></a>
                      </td>
                    <td className="pt3 pa2" style={{ minWidth: "170px" }}>
                      <a href={`mailto:vertrieb@trendimport.de?subject=Anfrage bezüglich des Bestellvorgangs, Kunde #${shop.session.value.map_id}`}>
                        <span className="f6 fw5" style={{ color: "#e15635", backgroundColor: "transparent" }}><Icon
                      name={"mail"} />vertrieb@trendimport.de</span></a>
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
        <NewCustomerContactPage />

      </section> }

      {openTab == "frameworkAgreement" && <Fragment>
                      <div className="pb3 pt3">
          <p className="f2 fw7"> {translate( "Rahmenaufträge" )}</p>
        </div>
              {orders.length >= 0 && <OrderTable rahmenauftrag={true} orders={orders}/>}
              {!orders.length && <p className="black-60">{translate( "No Orders" )}</p>}
              {noMoreOrders && <div>{translate( "Gesamter Bestellverlauf wird angezeigt" )}</div>}

        </Fragment>}

        {openTab == "newsletter" && <Fragment>
          <MediaQuery minWidth={768}>
          <table>
            <colgroup>
              <col width="40%"/>
              <col width="60%"/>
            </colgroup>
            <tbody>

              <tr>
                <td className="tl ">
                  <div className="pb3 mt5 pt5 bt bw2 mr4">
                    <div className="f2 fw6 pb3"> {translate( "Neues entdecken." )}</div>
                    <div className="f2 fw6 pt2"> {translate( "Informiert bleiben." )}</div>
                  </div>
                </td>
                <td className="tl" style={{ verticalAlign: "top" }}>
                  <div className="w-70  ml3 mt5 pt5">
                    <div className="fw5 f5">{translate( "Bleiben Sie immer auf dem Laufenden – mit unseren Produkt-Highlights, exklusiven Aktionen und den neuesten Unternehmens-News." )}</div>

                  </div>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td><div className="ml3"><div className="fw5 f5">{translate( "Melden Sie sich jetzt an und verpassen Sie keine Vorteile mehr!" )}</div></div></td>
              </tr>
            </tbody>
          </table>
          </MediaQuery>
              <MediaQuery maxWidth={767}>
                <table>
                <colgroup>
                  <col width="100%"/>
                </colgroup>
                <tbody>
                    <tr>
                      <td>
                          <div className="pb3 mt5 pt5 bt bw2 mr4">
                          <div className="f2 fw6 pb3"> {translate( "Neues entdecken." )}</div>
                          <div className="f2 fw6 pt2"> {translate( "Informiert bleiben." )}</div>
                      </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                                          <div className="pt4">
                        <div className="fw5 f4">{translate( "Bleiben Sie immer auf dem Laufenden – mit unseren Produkt-Highlights, exklusiven Aktionen und den neuesten Unternehmens-News." )}</div>
                        <div className="pt4 fw5 f4">{translate( "Melden Sie sich jetzt an und verpassen Sie keine Vorteile mehr!" )}</div>
                      </div>
                      </td>
                    </tr>
                </tbody>
                </table>
              </MediaQuery>
          <NewCustomerContactPage newsletter={true} /></Fragment>}
        {/* openTab == "frameworkAgreement" && <section className="mt4 pb4"> RAHMENAUFTRAG
        <h2>{translate("Rahmenaufträge")}</h2>
        <Table>
          <colgroup>
            <col width="10%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="20%"/>
            <col width="10%"/>
          </colgroup>
          <Table.Header className="bg-light-gray bb b--black-20">
            <td className="fw6 f5">{translate("Artikel")}</td>
            <td className="fw6 f5">&nbsp;</td>
            <td className="fw6 f5">{translate("RahmenAuftragsID")}</td>
            <td className="fw6 f5">{translate("Abgerufene Menge")}</td>
            <td className="fw6 f5">{translate("Zeitraum")}</td>
            <td className="fw6 f5">{translate("PDF Details")}</td>
          </Table.Header>
          <tbody>
            <Fragment>
              <tr>
                <td>
                  <Link to={`/product/${10030}`}>
                    <img
                      className="db center"
                      style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
                      src={"BASEURL/shop/rest/data/images/description/1011300/1?size=small"}
                      alt=""/>
                  </Link>
                </td>
                <td>Steristopfen 10</td>
                <td>123456789</td>
                <td>250/500</td>
                <td>01.04.2025 - 01.07.2025</td>
                <td>2500,00 EUR</td>
              </tr>
              <tr>
                <td colSpan="6" className="bb b--black-50">
                  <Progress percent={Number((250 / 500) * 100).toFixed(2)} progress="percent" color="green" />
                </td>
              </tr>
            </Fragment>
            <Fragment>
              <tr>
                <td>
                  <Link to={`/product/${10030}`}>
                    <img
                      className="db center"
                      style={{maxWidth: "35px",maxHeight: "35px", minWidth: "35px",minHeight: "35px", overflow: "hidden",objectFit: "contain"}}
                      src={"BASEURL/shop/rest/data/images/description/1011300/1?size=small"}
                      alt=""/>
                  </Link>
                </td>
                <td>Steristopfen 15</td>
                <td>TESTRAHMENAUFTRAG</td>
                <td>137/1337</td>
                <td>01.01.2025 - 01.01.2026</td>
                <td>3750,00 EUR</td>
              </tr>
              <tr>
                <td colSpan="6" className="">
                  <Progress percent={Number((137 / 1337) * 100).toFixed(2)} progress="percent" color="green" />
                </td>
              </tr>
            </Fragment>
          </tbody>
        </Table>

        </section> */}


        {/*<pre>Session: {JSON.stringify(session, null, 2)}</pre>*/}
        {/*<pre>Adressen:{JSON.stringify(this.state.locations, null, 2)}</pre>*/}
      </div>
        </div>

    </Fragment>

    )
  }
}

const Adresses = ( { billingAddress, openTab } ) => {

  return (
<Fragment>
  <MediaQuery minWidth={768}>
  <Table className="accountPageAddressTable" >
        <colgroup>
          <col width="50%"/>
          <col width="50%"/>
        </colgroup>
        <tbody>
        <tr>
          <td>
            <div className="fw6 bb pb2" style={{width: "97%"}}>{translate( "Rechnungsadresse" )}</div>
          <div className="AccountPageAddress" sm="1" style={{ minHeight: "250px" }}>
            <div className="w-100">
              <div className="pt3 f5 fw5">
              <p className="">{billingAddress.title}</p>
              <p>{billingAddress.street} </p>
              <p>{billingAddress.pcode} {billingAddress.city}</p>
              <p>{billingAddress.country}</p>
              <p className="pt2 black-60">
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </p>
              </div>
            </div>
          </div>
          </td>
          <td>
          { openTab == "address" && 
          <Fragment>
            <div className="bb w-100 pb2">{translate( "Lieferadresse" )}</div>
          <div className="AccountPageAddress" sm="1" style={{ minHeight: "250px" }}>
            <div className="">
              <div className="pt3 f5 fw5">
              <p className=""> {billingAddress.title}</p> 
              <p>{billingAddress.street} </p>
              <p>{billingAddress.pcode} {billingAddress.city}</p>
              <p>{billingAddress.country}</p>
              <p className="pt2 black-60">
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </p>
              </div>
            </div>
          </div>
          </Fragment>}
          </td>
          </tr>
          </tbody>
  </Table>
    </MediaQuery>
  <MediaQuery maxWidth={767}>
      <table className="accountPageAddressTable" >
        <colgroup>
          <col width="50%"/>
          <col width="50%"/>
        </colgroup>
        <tbody>
        <tr>
          <td>

          </td>
          <td>

          </td>
          </tr>
          </tbody>
  </table>
            <div className="fw6 bb pb2" style={{width: "97%"}}>{translate( "Rechnungsadresse" )}</div>
          <div className="AccountPageAddress" sm="1" style={{ minHeight: "250px" }}>
            <div className="w-100">
              <div className="pt3 f5 fw5">
              <p className="">{billingAddress.title}</p>
              <p>{billingAddress.street} </p>
              <p>{billingAddress.pcode} {billingAddress.city}</p>
              <p>{billingAddress.country}</p>
              <p className="pt2 black-60">
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </p>
              </div>
            </div>
          </div>
          { openTab == "address" && 
          <Fragment>
            <div className="bb w-100 pb2">{translate( "Lieferadresse" )}</div>
          <div className="AccountPageAddress" sm="1" style={{ minHeight: "250px" }}>
            <div className="">
              <div className="pt3 f5 fw5">
              <p className=""> {billingAddress.title}</p> 
              <p>{billingAddress.street} </p>
              <p>{billingAddress.pcode} {billingAddress.city}</p>
              <p>{billingAddress.country}</p>
              <p className="pt2 black-60">
              {billingAddress.email && <div>{billingAddress.email}</div>}
              {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </p>
              </div>
            </div>
          </div>
          </Fragment>}
    </MediaQuery>

      </Fragment>
  )
}

const OrderTable = ( { orders, rahmenauftrag, onOrderClick } ) => {
  if ( orders.length === 0 ) {
    return null
  }

  return (
    <Fragment>
      <MediaQuery minWidth={768}>
    <div className="table-scroller">
      <Table className={rahmenauftrag ? "orderTableAccountRahmen" : "orderTableAccount"} >
        <colgroup>
          <col width="20%"/>
          <col width="12%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="25%"/>
        </colgroup>

        <tbody>
        <tr>
          <th className="ttu"> {rahmenauftrag ? translate( "Rahmenauftragsnummer" ) : translate( "order number" )}</th>
          <th className="ttu tl">{rahmenauftrag ? translate( "Abrufbar bis" ) : translate( "date" )}</th>
          <th className="ttu tl">{translate( "price" )}</th>
          <th className="ttu tl">{translate( "positions" )}</th>
          <th className="ttu tl">{translate( "status" )}</th>
          <th className="ttu tl">&nbsp;</th>
        </tr>

        {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow id="AccountPageOrderHistoryTableRow" rahmenauftrag={rahmenauftrag} key={order.id} order={order} onOrderClick={onOrderClick}/> )}
        </tbody>
      </Table>
    </div>
        </MediaQuery>
        <MediaQuery maxWidth={767}>
          <div>
          <table>
            <colgroup>
              <col width={rahmenauftrag ? "80%" : "70%"} />
              <col width="40%"/>
            </colgroup>
            <tbody>
              {orders.length > 0 && orders.map( ( order ) => <OrderPreviewRow className="AccountPageOrderHistoryTableRow" rahmenauftrag={rahmenauftrag} key={order.id} order={order} onOrderClick={onOrderClick}/> )}

            </tbody>
          </table>
          </div>
        </MediaQuery>

    </Fragment>
  )
}

const OrderPreviewRow = ( { order, rahmenauftrag, onOrderClick } ) => {
  const [reorderModalOpen, setReorderModalOpen] = useState(false)
  const orderDate = rahmenauftrag ? moment( order.deliverdate ).format( "DD.MM.YYYY" ) : moment( order.register ).format( "DD.MM.YYYY" )

  const orderLink = `/account/orders/${order.map_id}`
  const isSuccess = (order.status === "2" || order.status === 2)
  let rahmenauftragStatus = rahmenauftrag && order.deliverdate && moment(order.deliverdate).isValid() && moment(order.deliverdate).isAfter(moment(), 'day')
    ? <span style={{ color: "#e15635" }}>{translate("Aktiv")}</span>
    : <span style={{ color: "red" }}>{translate("Abgelaufen")}</span>;
  let orderstateCounter = 0
  let orderstate = 0
  let orderstateArray = [translate("Vollständig geliefert"), translate("Rückstand"), translate("Teilweise geliefert")];
  let maxArticle = 0;
  let usedArticle = 0;
  let rahmenauftragartikel = "";
  const { currentLanguage } = languageStore
  if(!rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){
    console.log("rahmenauftrag", order)
    return null
  }
  else if (rahmenauftrag && order.extras && !order.extras.rahmenauftrag){
    return null
  }

  if(rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){

    if (order.positions && Array.isArray(order.positions)) {
      order.positions.forEach(product => {
        console.log("product", product, product.count, product.open, product.unit_multi, product.open / product.unit_multi)
        maxArticle += Number(product.count) || 0;
        usedArticle += (Number(product.open) || 0) / (Number(product.unit_multi) || 1);
      });
    }
    console.log("maxArticle", maxArticle, " usedArticle", usedArticle)
  }

  for(let i = 0; order.positions.length > i; i++){
    if(order.positions[i].open != 0){
      orderstateCounter++
    }

    if(rahmenauftrag && order.extras && order.extras.rahmenauftrag && order.extras.rahmenauftrag == "1"){
      if (order.positions[i].article_nr) {
          rahmenauftragartikel = order.positions.map(
            (article) => (
              <div key={article.article_nr}>
                {console.log("article", article.article_nr)}
                {article.article_nr}
              </div>
            )
        );
      }
    }
  }
  console.log("orderstatecounter: ", orderstateCounter, " order.length: ", order.positions.length)
  if(orderstateCounter == order.positions.length){
    orderstate = 1
  }
  if(orderstateCounter < order.positions.length){
    orderstate = 2
  }
  if(orderstateCounter == 0){
    orderstate = 0
  }
  console.log("order", order )

  return (
    <Fragment>
      <MediaQuery minWidth={768}>
        <tr id="AccountPageOrderHistoryTableRow">
          <td>
            {onOrderClick
              ? <span className="fw7 f5" style={{ color: "#e15635", cursor: "pointer" }} onClick={() => onOrderClick(order.map_id)}>
                  #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
                </span>
              : <Link className="fw7 f5" style={{ color: "#e15635" }} to={orderLink}>
                  #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
                </Link>
            }
          </td>
          <td className="tl">
            <div className="nowrap">{orderDate}</div>
          </td>
          <td className="tl"><Price>{order.netto}</Price></td>
          <td className={rahmenauftrag ? "tr" : "tl"}>{rahmenauftrag ? order.positions.length : order.positions.length}</td>
          <td className="tl">
            {rahmenauftrag ? rahmenauftragStatus : translate(orderstateArray[orderstate])}
          </td>
          <td className="tl">
            <Button
              id="defaultButtonAccount"
              primary
              {...(onOrderClick
                ? { onClick: () => onOrderClick(order.map_id) }
                : { as: Link, to: orderLink }
              )}
            >
              <p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>
                {rahmenauftrag ? translate("Rahmenauftrag ansehen") : translate("Bestellung ansehen")}
              </p>
            </Button>
            {order.extras && order.extras.tracking && !rahmenauftrag && <div className="product-inner fr pt3" >
              <Button
              as="a"
              href={`//tracking.dpd.de/status/${currentLanguage == "de" ? "de_DE" : "en_US"}/parcel/${order.extras.tracking}`}
              style={{
                backgroundColor: "#a50c53",
                color: "white",
                width: "300px",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }} primary><p className="fw6">{translate( "Sendungsverfolgung" )}</p></Button></div>}
            {shop.config.plugin && shop.config.plugin.oneClickReorder && !rahmenauftrag && (
              <div className="pt3">
                <Button primary id="oneClickReorderButtonAccount"
                  onClick={() => setReorderModalOpen(true)}
                >
                  <Icon name="redo alternate" />
                  <p className="fw6" style={{ margin: 0 }}>{translate("Erneut bestellen")}</p>
                </Button>
              </div>
            )}
            {shop.config.plugin && shop.config.plugin.downloadProductImages && order.positions && order.positions.length > 0 && (
              <div className="pt3">
                <ProductImageDownloader articles={order.positions.map(p => ({ id: p.article_nr || p.article_id, title: p.title || p.article_nr }))} />
              </div>
            )}

          </td>

        </tr>
      </MediaQuery>
      <MediaQuery maxWidth={767}>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{rahmenauftrag ? translate( "Rahmenauftragsnummer" ) : translate( "order number" )}:</p>
          </td>
          <td className="tr pa2 fw7 f5">
            {onOrderClick
              ? <span className="fw7 f5" style={{ color: "#e15635", cursor: "pointer" }} onClick={() => onOrderClick(order.map_id)}>
                  #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
                </span>
              : <Link className="fw7 f5" style={{ color: "#e15635" }} to={orderLink}>
                  #{order.map_id} {order.comment ? `- ${order.comment}` : ""}
                </Link>
            }
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("date")}:</p>
          </td>
          <td className="tr pa2 fw7 f5">
            <div className="nowrap">{orderDate}</div>
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("price")}:</p>
          </td>
          <td className="tr pa2 fw7 f5">
            <Price>{order.netto}</Price>
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("positions")}:</p>
          </td>
          <td className="tr pa2 fw7 f5">
            {order.positions.length}
          </td>
        </tr>
        <tr>
          <td className="tl pa2 fw7 f5">
            <p>{translate("Status")}:</p>
          </td>
          <td className="tr pa2 fw7 f5">
            {rahmenauftrag ? rahmenauftragStatus : translate(orderstateArray[orderstate])}
          </td>
        </tr>
        <tr>
          <td
            className="tr"
            colSpan={2}
            style={{
              borderBottom: "3px solid #e15635",
              padding: "10px"
            }}
          >
            <Button
              primary
              id="defaultButtonAccount"
              {...(onOrderClick
                ? { onClick: () => onOrderClick(order.map_id) }
                : { as: Link, to: orderLink }
              )}
            >
              <p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>
                {rahmenauftrag ? translate("Rahmenauftrag ansehen") : translate("Bestellung ansehen")}
              </p>
            </Button>

            {order.extras && order.extras.tracking && !rahmenauftrag &&<Fragment><div className="pt2"></div>
              <Button
              as="a"
              href={`//tracking.dpd.de/status/${currentLanguage == "de" ? "de_DE" : "en_US"}/parcel/${order.extras.tracking}`}
              style={{
                backgroundColor: "#b814b8",
                color: "white",
                width: "100%",
                borderRadius: "35px",
                height: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }} primary><p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>{translate( "Sendungsverfolgung" )}</p></Button></Fragment>}
            {shop.config.plugin && shop.config.plugin.oneClickReorder && !rahmenauftrag && (
              <Fragment>
                <div className="pt2"></div>
                <Button
                  style={{
                    width: "100%",
                    borderRadius: "35px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#e15635",
                    color: "#fff",
                  }}
                  onClick={() => setReorderModalOpen(true)}
                >
                  <Icon name="redo alternate" />
                  <p className="fw6 f5" style={{ textAlign: "center", margin: 0, width: "100%" }}>{translate("Erneut bestellen")}</p>
                </Button>
              </Fragment>
            )}
            {shop.config.plugin && shop.config.plugin.downloadProductImages && order.positions && order.positions.length > 0 && (
              <Fragment>
                <div className="pt2"></div>{console.log("order.positions", order.positions)}
                <ProductImageDownloader articles={order.positions.map(p => ({ id:  p.article_nr || p.article_id, title: p.title || p.article_nr }))} />
              </Fragment>
            )}
          </td>
        </tr>
      </MediaQuery>
      {reorderModalOpen && (
        <OneClickReorderModal
          open={reorderModalOpen}
          order={order}
          onClose={() => setReorderModalOpen(false)}
        />
      )}
    </Fragment>
  )
}

const Address = ( { title, location } ) => {
  const isDeliveryAddress = location.mapid === (shop.cart.deliveraddress && shop.cart.deliveraddress.mapid)
  return (
    <React.Fragment>
      
      <div className="address-block pb3">
        <div className="pt3 pb2 fw6 w-90 bb">{translate("Lieferadresse")}</div>
        <p className="pt3">{location.name1} {location.name2} {location.name3}</p>
        <div className=""><p>{location.company ? location.company : null}</p>
          <p>{location.street ? location.street : null}</p>
          <p>{location.pcode} {location.city}</p>
          <p>{location.country}</p>
        </div>
        <div className="pt3">
        </div>
      </div>
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/theme/trendimport.test/pages/AccountPage.js